/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnQrRedeemResponse
 */
export interface EarnQrRedeemResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EarnQrRedeemResponse
     */
    redeemed: boolean;
    /**
     * True when this user already redeemed within the token's dedup scope. Idempotent success, not an error.
     * @type {boolean}
     * @memberof EarnQrRedeemResponse
     */
    alreadyRedeemed: boolean;
    /**
     * The token's human-readable label, for the confirmation toast.
     * @type {string}
     * @memberof EarnQrRedeemResponse
     */
    label?: string;
}

/**
 * Check if a given object implements the EarnQrRedeemResponse interface.
 */
export function instanceOfEarnQrRedeemResponse(value: object): value is EarnQrRedeemResponse {
    if (!('redeemed' in value) || value['redeemed'] === undefined) return false;
    if (!('alreadyRedeemed' in value) || value['alreadyRedeemed'] === undefined) return false;
    return true;
}

export function EarnQrRedeemResponseFromJSON(json: any): EarnQrRedeemResponse {
    return EarnQrRedeemResponseFromJSONTyped(json, false);
}

export function EarnQrRedeemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnQrRedeemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redeemed': json['redeemed'],
        'alreadyRedeemed': json['alreadyRedeemed'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function EarnQrRedeemResponseToJSON(json: any): EarnQrRedeemResponse {
    return EarnQrRedeemResponseToJSONTyped(json, false);
}

export function EarnQrRedeemResponseToJSONTyped(value?: EarnQrRedeemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redeemed': value['redeemed'],
        'alreadyRedeemed': value['alreadyRedeemed'],
        'label': value['label'],
    };
}

